import { inject, Pipe, PipeTransform } from '@angular/core';
import { ComplexArticleBlueprintFactory } from '@admintool/article/generate-article/complex-article-blueprints/services/complex-article-blueprint.factory';
import { ComplexArticleRule } from '@admintool/article/generate-article/complex-article-blueprints/complex-article-blueprint';

@Pipe({name: 'complexArticleRuleFromUsage'})
export class ComplexArticleRuleFromUsagePipe implements PipeTransform {
  private readonly complexArticleBlueprintRuleFactory = inject(ComplexArticleBlueprintFactory);

  transform(ruleName: string): ComplexArticleRule | undefined {
    return this.complexArticleBlueprintRuleFactory.findRule(ruleName);
  }
}
